import * as APIStore from "../../store/APIStore";

export const formatGreetingByPractice = (curGreeting: String,
    practiceName: String) => {


    if (practiceName) {
        return `Attention: ${practiceName}`
    }

    return curGreeting;
}